import React, { useState } from 'react';
import { Alert } from 'react-bootstrap';
import { TransactionForm } from '../TransactionForm';
import { useAuth } from '../../hooks/useAuth';
import { API_BASE_URL } from '../../config/api';
import { getAgentId } from '../../utils/agentId';
import { buildTransactionPayload } from '../../utils/transactionPayload';

/**
 * TransactionFloatingForm - Transaction creation form for floating window
 * Wraps TransactionForm with submission logic
 */
export default function TransactionFloatingForm({ onSubmit, onCancel }) {
  const [error, setError] = useState(null);
  const { apiCall, user } = useAuth();

  const handleSubmit = async (formData) => {
    try {
      setError(null);

      const agentId = await getAgentId(apiCall, user);
      const transactionData = buildTransactionPayload(formData, agentId);

      await apiCall(`${API_BASE_URL}/transactions`, {
        method: 'POST',
        body: JSON.stringify(transactionData)
      });

      onSubmit?.();
    } catch (err) {
      setError(err.message || 'Failed to create transaction');
      throw err;
    }
  };

  return (
    <>
      {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
      <TransactionForm
        apiCall={apiCall}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        submitLabel="Create Transaction"
        user={user}
      />
    </>
  );
}
